import { OrderItem } from '../types';
import { ORDER_STATUS, OrderStatusValue } from '../../../../../generic/ui/Selectors/OrderStatusSelector';
import { ORDER_AKPACA_TYPE, OrderAkpacaTypeValue } from '../../../../../generic/ui/Selectors/OrderAkpacaTypeSelector';
import { readSessionNumber } from '../../../../../generic/utils/warehouseDefaults';

export const matchesInput = (item: OrderItem, input: string): boolean => {
    const needle = input.toLowerCase();
    const orderIdString = String(item.OrderID);
    return (
        item.Customer_Name.toLowerCase().includes(needle) ||
        orderIdString.toLowerCase().includes(needle)
    );
};

export interface IOrderFilterCriteria {
    input: string;
    statusId: OrderStatusValue;
    warehouseID: number;
    typeFilter: OrderAkpacaTypeValue;
    /** Order group (product/group); 0 or unset — all groups. */
    groupID?: number;
}

/** Client-side list filter: status, warehouse, הקפצה type and search — all criteria combined (AND). */
export const filterOrders = (
    list: OrderItem[],
    { input, statusId, warehouseID, typeFilter, groupID = 0 }: IOrderFilterCriteria,
): OrderItem[] =>
    list.filter(
        (item) =>
            (statusId === ORDER_STATUS.ALL || item.Status === statusId) &&
            (warehouseID === 0 || item.WarehouseID === warehouseID) &&
            (typeFilter === ORDER_AKPACA_TYPE.ALL || item.Type === typeFilter) &&
            (groupID === 0 || item.GroupID === groupID) &&
            (!input || matchesInput(item, input)),
    );

export interface IOrderActiveFiltersInput {
    isWarehouseFilterVisible: boolean;
    warehouseID: number;
    typeFilter: OrderAkpacaTypeValue;
    statusId: OrderStatusValue;
    groupID?: number;
}

/** Active filters shown on the filter chip; a hidden warehouse field never counts. */
export const countActiveOrderFilters = ({
    isWarehouseFilterVisible,
    warehouseID,
    typeFilter,
    statusId,
    groupID = 0,
}: IOrderActiveFiltersInput): number =>
    (isWarehouseFilterVisible && warehouseID !== 0 ? 1 : 0) +
    (typeFilter !== ORDER_AKPACA_TYPE.ALL ? 1 : 0) +
    (statusId !== ORDER_STATUS.ALL ? 1 : 0) +
    (groupID !== 0 ? 1 : 0);

export const ORDERS_WAREHOUSE_SESSION_KEY = 'selectedWarehouseOrders';

/** Warehouse chosen in this session; until one is chosen — `defaultWarehouseID` (the user's transit). */
export const getOrdersWarehouseFromSession = (defaultWarehouseID = 0): number =>
    readSessionNumber(ORDERS_WAREHOUSE_SESSION_KEY, defaultWarehouseID);
